<template>
	<pre v-html="$t('terms.legal_indication3')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication3',
};
</script>

<style scoped></style>
